import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function StudentCard({
  isCorrect,
  TextValue,
  startListening,
  isTeacherTurn,
  isListening,
  transcript,
  similarityScore,
  getFeedbackMessage,
  getSimilarityColor,
  activeLevel,
}) {
  const [changeContent, setChangeContent] = useState("");
  const contentValue = useSelector((state) => state.contents.contentValues);

  const changeValue = (contentValue, activeLevel) => {
    let currentContent = "";
    if (contentValue.section === "reading" && activeLevel === "verbs") {
      currentContent = contentValue?.verbs?.[TextValue];
    }
    if (contentValue.section === "reading" && activeLevel === "Story") {
      currentContent = contentValue?.Articles?.Story;
    }
    if (contentValue.section === "vocabulary") {
      currentContent = contentValue?.contents?.[TextValue];
    }
    if (contentValue.section === "grammar" && activeLevel === "examples") {
      currentContent = contentValue?.examples?.[TextValue];
    }
    if (contentValue.section === "grammar" && activeLevel === "exercises") {
      currentContent = contentValue?.exercises?.[TextValue];
    }
    return currentContent;
  };

  useEffect(() => {
    const returnvalue = changeValue(contentValue, activeLevel);
    if (returnvalue) {
      setChangeContent(returnvalue);
    } else {
      setChangeContent("");
    }
  }, [activeLevel, contentValue, TextValue]);

  return (
    <div
      className={`${
        !isTeacherTurn ? "bg-yellow-500" : "bg-gray-200"
      } rounded-2xl p-4 md:p-6 shadow-xl border-l-4 ${
        !isTeacherTurn ? "border-purple-500" : "border-gray-400"
      } hover:shadow-2xl transition-all ${
        activeLevel === "Advanced" ? "md:col-span-2" : ""
      }`}
    >
      {/* Üst kısım - Buton ve başlık (transcript yokken göster) */}
      {(!transcript || transcript.trim() === "") && (
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-4">
          <div className="sm:flex items-center gap-2 hidden">
            <span className="text-xl md:text-3xl">👨‍🎓</span>
            <div className="flex flex-col">
              <p
                className={`text-lg md:text-xl font-bold ${
                  isTeacherTurn ? "text-gray-500 " : "text-gray-800"
                }`}
              >
                Student (You)
              </p>
              <hr className="border-b-2 border-purple-500" />
              <p>Öğrenci(siz)</p>
            </div>
          </div>
          <button
            onClick={startListening}
            disabled={isTeacherTurn || isListening}
            className={`px-6 py-3 font-semibold rounded-lg shadow-md
              transition-all flex items-center gap-2 text-sm md:text-base
              w-full sm:w-auto justify-center ${
                !isTeacherTurn && !isListening
                  ? "bg-purple-500 hover:bg-purple-600 text-white"
                  : "bg-gray-400 text-gray-100 cursor-not-allowed"
              }`}
          >
            <span className="text-3xl">🎤</span>
            <div className="flex flex-col">
              <p> {isListening ? "Listening..." : "Speak"}</p>
              <hr className="border-b-2 border-yellow-500" />
              <p className="text-sm font-normal">
                {isListening ? "konuşuluyor..." : "konuşma"}
              </p>
            </div>
          </button>
        </div>
      )}

      {/* Transcript gösterim alanı */}
      {transcript && transcript.trim() !== "" && (
        <div className=" grid grid-cols-6 gap-2 justify-center items-center">
          {/* Transcript ve bar bilgisi */}
          <div className={`${isCorrect ? "col-span-6" : "col-span-4"}`}>
            <div
              className={`mt-4 p-3 border-l-4 rounded-2xl ${
                isCorrect
                  ? "bg-green-50 border-green-500"
                  : "bg-yellow-50 border-yellow-500"
              }`}
            >
              {/* <p
                className={`text-sm font-semibold ${
                  isCorrect ? "text-green-700" : "text-yellow-700"
                }`}
              >
                {isCorrect ? "Doğru! 🎉 (Otomatik geçiliyor...)" : "You said:"}
              </p> */}
              <p className="text-gray-800 text-sm md:text-base break-words">
                {transcript}
              </p>

              {/* Benzerlik skoru gösterimi bar - her zaman tam genişlik */}
              {similarityScore > 0 && (
                <div className=" px-2 py-0.5 bg-blue-50 rounded-lg">
                  <div className="flex justify-between items-center">
                    <span
                      className={`text-sm font-bold ${getSimilarityColor(
                        similarityScore,
                      )}`}
                    >
                      {(similarityScore * 100).toFixed(1)}%
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
                    <div
                      className={`h-2 rounded-full ${
                        similarityScore >= 0.8
                          ? "bg-green-500"
                          : similarityScore >= 0.6
                            ? "bg-yellow-500"
                            : "bg-red-500"
                      }`}
                      style={{ width: `${similarityScore * 100}%` }}
                    ></div>
                  </div>
                </div>
              )}

              {!isCorrect && (
                <p className="text-xs text-gray-500 mt-1 break-words">
                  Beklenen: {changeContent.Eng || changeContent}
                </p>
              )}
            </div>
          </div>

          {/* Buton - sadece yanlış olduğunda ve transcript varsa göster */}
          <div className="col-span-2">
            {!isCorrect && (
              <div className="mt-3 flex justify-end">
                <button
                  onClick={startListening}
                  disabled={isTeacherTurn || isListening}
                  className={`px-6 py-3 font-semibold rounded-lg shadow-md
                  transition-all flex items-center gap-2 text-sm md:text-base
                  w-full sm:w-auto justify-center ${
                    !isTeacherTurn && !isListening
                      ? "bg-purple-500 hover:bg-purple-600 text-white"
                      : "bg-gray-400 text-gray-100 cursor-not-allowed"
                  }`}
                >
                  <span className="text-3xl">🎤</span>
                  <div className="flex flex-col">
                    <p>{isListening ? "Listening..." : "Speak"}</p>
                    <hr className="border-b-2 border-yellow-500" />
                    <p className="text-sm font-normal">
                      {isListening ? "konuşuluyor..." : "konuşma"}
                    </p>
                  </div>
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default StudentCard;
